import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { DayOfWeekPeriodString } from '@/pages/menu-managements/business-hours/service';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuService } from '@/services/BrandMenu/MenuManagementBrandMenuService';

export type ShowMenuResponse = {
  id: string;
  title: Title;
  memo: string | null;
  day_of_week_periods: DayOfWeekPeriodString[];
  brand_category_sort_objects: SearchItem[];
};

export const useMenuManagementBrandMenuShow = async (
  id: string
): Promise<ShowMenuResponse> => {
  const menuManagementBrandMenuService = new MenuManagementBrandMenuService(
    getClient()
  );
  try {
    const res = await menuManagementBrandMenuService.show(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
